<template>
  <p class="demand-dates">{{ datesDisplay }}</p>
</template>

<script>
  import { DISPLAY_SHORT_DATE } from "@core/constants";

  export default {
    props: {
      startDate: {
        type: Object,
        default: () => ({}),
      },
      endDate: {
        type: Object,
        default: () => ({}),
      },
      startTime: {
        type: String,
        default: "",
      },
      isOneDay: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      datesDisplay() {
        if (!this.startTime) {
          const start = this.startDate.format(DISPLAY_SHORT_DATE);
          const end = this.endDate.format("DD/MM");
          return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@DATES_DISPLAY_NO_TIME", { start, end });
        }

        if (this.isOneDay) {
          const date = this.startDate.format(DISPLAY_SHORT_DATE);
          return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@DATES_DISPLAY_SINGLE", { date, time: this.startTime });
        }

        const start = this.startDate.format(DISPLAY_SHORT_DATE);
        const end = this.endDate.format("DD/MM");
        return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@DATES_DISPLAY", { start, time: this.startTime, end });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .demand-dates {
    margin: 0;
    color: $primary;
  }
</style>
